module.exports = __webpack_public_path__ + "static/media/radio-on.f26d23fc.svg";